export enum PROFILE_STATE {
    ACTIVE = 'A',
    BLOCKED = 'B',
    REJECTED = "R",
    NEW = 'N',
    PENDING = 'P',
    DECLINED = 'D',
    SUSPENDED = 'S',
    PROCESSING = 'V',
    ON_HOLD = 'O',
    ARCHIVED = 'C',
    CLOSED = 'F'
}

export enum PROFILE_STATE_NAMES {
    ACTIVE = 'ACTIVE',
    BLOCKED = 'BLOCKED',
    REJECTED = "REJECTED",
    NEW = 'NEW',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    SUSPENDED = 'SUSPEND',
    PROCESSING = 'PROCESSING',
    ON_HOLD = 'ON HOLD',
    ARCHIVED = 'ARCHIVED'
}

export enum PROFILE_PROVIDERS_NAMES {
    MODULR = 'MODULR',
    MOORWAND = 'MOORWAND',
    AGENT = 'AGENT',
    EMONEY = 'EMONEY'
}

export enum PROFILE_TYPE {
    PRIVATE = 1,
    CORPORATE = 2
}

export const PROFILE_KIND = {
    CUSTOMER: 1,
    AGENT: 2,
    SALESMAN: 3,
    SALESMAN_LEAD: 4,
    WHITE_LABEL: 5,
    INSTITUTIONAL_CLIENT: 6,
    SUB_CLIENT: 7
};

export const IDENTIFICATION_STATUS = {
    VERIFIED: 'VERIFIED',
    IN_PROGRESS: 'IN_PROGRESS',
    NOT_VERIFIED: 'NOT_VERIFIED',
    NEED_VERIFICATION: 'NEED_VERIFICATION',
    NEED_RE_VERIFICATION: 'NEED_RE_VERIFICATION'
};


export const FOURSTOP_STATUS = {
    PROCESSED_BY_FOURSTOP: true
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/profile.ts